module.exports = __webpack_public_path__ + "img/375.2f445a60.jpg";